export default {
  labels: {
    dont_have_account: 'Noch kein Konto? ',
  },
  title: 'Tritt {{name}} bei!',
  default_program_name: 'Rewards Club',
  buttons: {
    sign_up: 'Registrieren',
  },
};
